// @ts-nocheck
/* eslint-enable */
// Actions
import ErrorActions from 'app/shared/flux/actions/ErrorActions';
import { FilterActions_fetchFilterFromUrlAndApi } from 'app/shared/flux/actions/FilterActions';

const loadFilterFromUrlAndApi = (reactContext) => {
  const { state, store, trace } = reactContext;
  const { pathname, query } = state;

  return store
    .dispatch(FilterActions_fetchFilterFromUrlAndApi(pathname, query))
    .then((response) => {
      trace.finishAsyncSpan({
        marker: 'FetchAreaWrapper#FilterActions_fetchFilterFromUrlAndApi',
      });

      return response;
    })
    .catch((error) => {
      store.dispatch(
        ErrorActions.errorHandler({
          error,
          errorLocation: 'component.areaPage.serverRouteWillMount#loadFilterFromUrlAndApi',
          errorClass: 'FilterActions',
        }),
      );
    });
};

export default loadFilterFromUrlAndApi;
